export const tutorialLinks = [
  {
    header: "Name & Location",
    links: [
      {
        title: "Find FDIC-Insured Institutions and Offices",
        fileName: "Find_FDIC_Insured_Institutions_and_Offices.pdf",
      },
      {
        title: "Find Your Bank’s Holding Company",
        fileName: "Find_Your_Banks_Holding_Company.pdf",
      },
      {
        title: "Review an Institution's History",
        fileName: "Review_an_Institutions_History.pdf",
      },
    ],
  },
  {
    header: "Financial Reporting",
    links: [
      {
        title: "Custom Financial Report – Create",
        fileName: "Custom_Financial_Report_Create.pdf",
      },
      {
        title:
          "Financial Reports (Including FFIEC Call Report, UBPR) - Create and Download",
        fileName:
          "Financial_Reports_Including_FFIEC_Call_Report_UBPR_Create_and_Download.pdf",
      },
      {
        title: "Trust Powers Granted - Identify FDIC-Insured Institutions",
        fileName: "Trust_Powers_Granted_Identify_FDIC_Insured_Institutions.pdf",
      },
      {
        title: "Trust Powers Exercised - Identify FDIC-Insured Institutions",
        fileName:
          "Trust_Powers_Exercised_Identify_FDIC_Insured_Institutions.pdf",
      },
    ],
  },
  {
    header: "Peer Group Comparison",
    links: [
      {
        title:
          "Compare One Institution to Peer Group - Utilizing Search Criteria",
        fileName:
          "Compare_One_Institution_to_Peer_Group_Utilizing_Search_Criteria.pdf",
      },
      {
        title: "Compare One Institution to Peer Group - Utilizing Cert List",
        fileName:
          "Compare_One_Institution_to_Peer_Group_Utilizing_Cert_List.pdf",
      },
      {
        title: "Custom Peer Group - Create, Save and Retrieve",
        fileName: "Custom_Peer_Group_Create_Save_and_Retrieve.pdf",
      },
      {
        title: "Custom Peer Group - Edit Saved Group",
        fileName: "Custom_Peer_Group_Edit_Saved_Group.pdf",
      },
      {
        title: "Custom Report - Retrieve Saved Report",
        fileName: "Custom_Report _Retrieve_Saved_Report.pdf",
      },
      {
        title: "Standard Peer Group Report – Create",
        fileName: "Standard_Peer_Group_Report_Create.pdf",
      },
    ],
  },
  {
    header: "Summary of Deposits",
    links: [
      {
        title: "Compare Summary of Deposits vs Financial Reporting",
        fileName: "Compare_Summary_of_Deposits_vs_Financial_Reporting.pdf",
      },
      {
        title: "Review Branch Office Deposits",
        fileName: "Review_Branch_Office_Deposits.pdf",
      },
      {
        title: "Summary Tables",
        fileName: "Summary_Tables.pdf",
      },
      {
        title: "Deposit Market Shares",
        fileName: "Deposit_Market_Share.pdf",
      },
      {
        title: "Growth Rate",
        fileName: "Growth_Rate.pdf",
      },
      {
        title: "Market Presence",
        fileName: "Market_Presence.pdf",
      },
      {
        title: "Pro-Forma",
        fileName: "Pro_Forma.pdf",
      },
      {
        title: "Custom Data Download",
        fileName: "Custom_Data_Download.pdf",
      },
      {
        title: "Manage Custom Content",
        fileName: "Summary_of_Deposits_Manage_Custom_Content.pdf",
      },
    ],
  },
  {
    header: "API For Data Miners and Developers",
    links: [
      { title: "Find Bulk Files", fileName: "Find_Bulk_Files.pdf" },
      {
        title: "Links to Create Common Financial Reports (.xlsx spreadsheet)",
        fileName: "All_Financial_Reports.xlsx",
      },
      {
        title: "Use the API with Examples",
        fileName: "Use_the_API_with_Examples.pdf",
      },
    ],
  },
  {
    header: "Find Events & Changes",
    links: [
      {
        title: "Review an Institution's Non-Financial Events and Changes",
        fileName:
          "Review_an_Institutions_ Non_Financial_Events_and_Changes.pdf",
      },
    ],
  },
  {
    header: "Find Annual Historical Bank Data",
    links: [
      {
        title: "Download Aggregated Historical Data for Institutions by Year",
        fileName:
          "Download_Aggregated_Historical_Data_for_Institutions_by_Year.pdf",
      },
    ],
  },
  {
    header: "Bank Failure & Assistance Data",
    links: [
      {
        title:
          "Download FDIC-Institutions' Failures and Assistance Transactions",
        fileName:
          "Download_FDIC_Insured_Institutions_Failures_and_Assistance_Transactions.pdf",
      },
    ],
  },
  {
    header: "Help-Glossary & Variable Definitions",
    links: [
      {
        title: "Use the Help Page",
        fileName: "Use_the_Help_Page.pdf",
      },
    ],
  },
  {
    header: "FOIA Links to Legacy Quarterly Financial Report Data Sets",
    links: [
      {
        directLink: true,
        title: "ZIP Archived Data Sets for Years 1992 to 2022",
        fileName:
          "https://www.fdic.gov/foia/quarterly-financial-reports-statistics-depository-institutions-sdi",
      },
    ],
  },
];
